import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </p>
        </div>

        <p className="text-xl mt-20">
          Hello Everyone!
          Myself Nishant Seth and I am a Practical knowledge seeker. To work in an environment where my skills and knowledge reflects the growth of the company and enhance my knowledge as well as experience. I like to make websites with react and tailwind. I also make smart contracts.
        </p>

        <br />

        <p className="text-xl">
          I have completed my classes 10 and 12 with 89.2 and 90.8 percent from K.V.no.1 A.F.S Agra and pursuing my B-Tech from VIT BHOPAL UNIVERSITY in Computer Science and Engineering with specialization in Artificial Intelligence and Machine Learning. In my senior secondary, I have taken computer science so from that point I gained an interest in computer science and artificial intelligence.
        </p>
      </div>
    </div>
  );
};

export default About;